module.exports = __webpack_public_path__ + "img/author.b3569416.png";